import styled from '@emotion/styled'

export const StyledA = styled.a`
  color: ${({ theme }) => theme.colors.text.black};
`
